import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=23b6af22&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalendarComponent.vue?vue&type=style&index=0&id=23b6af22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6af22",
  null
  
)

export default component.exports